import { render, staticRenderFns } from "./Marketmanagelog.vue?vue&type=template&id=04d992dc&scoped=true&"
import script from "./Marketmanagelog.vue?vue&type=script&lang=js&"
export * from "./Marketmanagelog.vue?vue&type=script&lang=js&"
import style0 from "./Marketmanagelog.vue?vue&type=style&index=0&id=04d992dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d992dc",
  null
  
)

export default component.exports